<template>
  <!-- 基本物价趋势 -->
  <div>
    <div class="table_container">
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="tableDataHistory"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-style="{ borderColor: '#dcdfe6' }"
      >
        <!-- 往年均价 -->
        <el-table-column label="往年均价" align="center">
          <!-- 年份 -->
          <el-table-column
            prop="years"
            label="年份"
            min-width="90px"
            align="center"
            class-name="disabled_column"
          />
          <!-- 油价 -->
          <el-table-column
            label="油价"
            align="center"
            class-name="disabled_column"
          >
            <!-- 汽油: 80# -->
            <el-table-column
              prop="gasoline80"
              label="汽油: 80#"
              min-width="90px"
              align="center"
              class-name="disabled_column"
            />
            <!-- 汽油: 92# -->
            <el-table-column
              prop="gasoline92"
              label="汽油: 92#"
              min-width="90px"
              align="center"
              class-name="disabled_column"
            />
            <!-- 汽油: 95# -->
            <el-table-column
              prop="gasoline95"
              label="汽油: 95#"
              min-width="90px"
              align="center"
              class-name="disabled_column"
            />
            <!-- 柴油: 标号2# -->
            <el-table-column
              prop="diesel2"
              label="柴油: 标号2#"
              min-width="90px"
              align="center"
              class-name="disabled_column"
            />
          </el-table-column>
          <!-- 电价 -->
          <el-table-column
            label="电价"
            align="center"
            class-name="disabled_column"
          >
            <!-- 家用 -->
            <el-table-column
              prop="electricPriceHouse"
              label="家用"
              min-width="90px"
              align="center"
              class-name="disabled_column"
            />
            <!-- 商用 -->
            <el-table-column
              prop="electricPriceCommercial"
              label="商用"
              min-width="90px"
              align="center"
              class-name="disabled_column"
            />
          </el-table-column>
          <!-- 气价 -->
          <el-table-column
            label="气价"
            align="center"
            class-name="disabled_column"
          >
            <!-- 家用 -->
            <el-table-column
              prop="gasPriceHouse"
              label="家用"
              min-width="90px"
              align="center"
              class-name="disabled_column"
            />
            <!-- 车用 -->
            <el-table-column
              prop="gasPriceCar"
              label="车用"
              min-width="90px"
              align="center"
              class-name="disabled_column"
            />
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="table_container">
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="tableData"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-style="{ borderColor: '#dcdfe6' }"
        :cell-class-name="cellClassName"
        @cell-click="handleCellClick"
      >
        <!-- 查询年 -->
        <el-table-column
          :label="`${queryParams.years}年`"
          align="center"
          class-name="disabled_column"
        >
          <!-- 分类 -->
          <el-table-column
            prop="typeName"
            label="分类"
            min-width="90px"
            align="center"
            class-name="disabled_column"
          />
          <!-- 价格 -->
          <el-table-column
            v-for="(item, index) in monthList"
            :key="index"
            :prop="item.priceField"
            :label="item.month"
            min-width="90px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="
                  editField === item.priceField && editIndex === scope.$index
                "
                id="focusRef"
                v-model="scope.row[item.priceField]"
                class="number_input"
                :controls="false"
                :precision="2"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              >
              </el-input-number>
              <div v-else>
                {{ scope.row[item.priceField] }}
              </div>
            </template>
          </el-table-column>
          <!-- 均价 -->
          <el-table-column
            prop="averagePrice"
            label="均价"
            min-width="90px"
            align="center"
            class-name="total_column"
          >
            <template slot-scope="scope">
              {{ getColumnAverage(scope.row, "averagePrice", "priceField") }}
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { addOrUpdateBasicPriceTrendsApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      tableDataHistory: [],
      tableData: [],
      editField: "", // 编辑单元格
      editIndex: -1, // 编辑行索引
      monthList: [
        {
          month: "1月",
          priceField: "oneData"
        },
        {
          month: "2月",
          priceField: "twoData"
        },
        {
          month: "3月",
          priceField: "threeData"
        },
        {
          month: "4月",
          priceField: "fourData"
        },
        {
          month: "5月",
          priceField: "fiveData"
        },
        {
          month: "6月",
          priceField: "sixData"
        },
        {
          month: "7月",
          priceField: "sevenData"
        },
        {
          month: "8月",
          priceField: "eightData"
        },
        {
          month: "9月",
          priceField: "nineData"
        },
        {
          month: "10月",
          priceField: "tenData"
        },
        {
          month: "11月",
          priceField: "elevenData"
        },
        {
          month: "12月",
          priceField: "twelveData"
        }
      ] // 月度
    };
  },
  methods: {
    init(
      data = { saleBasicPriceList: [], saleBasicPriceTypeList: [] },
      queryParams = {}
    ) {
      this.tableDataHistory = data.saleBasicPriceList || [];
      this.tableData = data.saleBasicPriceTypeList || [];
      this.queryParams = { ...queryParams };
    },
    // 获取当前行合计
    getColumnAverage(row, totalField, field) {
      let total = 0;
      let num = 0;
      this.monthList.forEach(item => {
        const value = Number(row[item[field]] ?? undefined);
        if (!isNaN(value)) {
          total += value;
          num++;
        }
      });
      row[totalField] = num === 0 ? 0 : (total / num).toFixed(0);
      return num === 0 ? 0 : (total / num).toFixed(0);
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          data: { saleBasicPriceTypeList: this.tableData }
        };
        const res = await addOrUpdateBasicPriceTrendsApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableDataHistory = res.data.saleBasicPriceList || [];
          this.tableData = res.data.saleBasicPriceTypeList || [];
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
